const constants = require('@/util/constants')
require('./config')

/**
 * 获取标签
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getTags (type, successcb, failedcb) {
  axios.get('/api/tag/get', {
    params: {
      'type': type,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建标签
 * @param {*} name 标签名
 * @param {*} isRobot 是否是智能
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createTag (name, successcb, failedcb) {
  axios.get('/api/tag/create', {
    params: {
      'name': name,
      'robot': false,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除标签
 * @param {*} id id
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteTag (id, successcb, failedcb) {
  axios.get('/api/tag/delete', {
    params: {
      'id': id,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
